module.exports = __webpack_public_path__ + "img/sea-2.0b0a7bc6.jpg";